import { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';

import { PromocodesPage } from './pages/PromocodesPage';
import { PromocodeCreatePage } from './pages/PromocodeCreatePage';
import { PromocodeEditPage } from './pages/PromocodeEditPage';
import { SHOP_CURRENT_ROUTE } from '../../utils/constants';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/promocodes`,
        element: <Outlet />,
        children: [
            {
                index: true,
                element: <PromocodesPage />,
            },
            {
                path: 'create',
                element: <PromocodeCreatePage />,
            },
            {
                path: ':promocodeId/edit',
                element: <PromocodeEditPage />,
            },
        ],
    },
];

export default routes;
